package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * Stripe Connect account status
 */
@Serializable
data class StripeConnectStatusDto(
    val connected: Boolean,
    val chargesEnabled: Boolean,
    val payoutsEnabled: Boolean,
    val onboardingCompleted: Boolean,
    val detailsSubmitted: Boolean,
    val country: String? = null,
    val stripeAccountId: String? = null,
)

/**
 * Onboarding link response
 */
@Serializable
data class OnboardingLinkDto(
    val url: String,
    val stripeAccountId: String? = null,
)

/**
 * Onboarding link request
 */
@Serializable
data class CreateOnboardingLinkRequestDto(
    val redirectUrl: String,
    val refreshUrl: String? = null,
)

/**
 * OAuth callback request
 */
@Serializable
data class StripeConnectCallbackDto(
    val code: String,
)

/**
 * OAuth callback response
 */
@Serializable
data class StripeConnectCallbackResponseDto(
    val success: Boolean,
    val accountId: String? = null,
    val onboardingCompleted: Boolean? = null,
)
